// extracted by mini-css-extract-plugin
module.exports = {"text":"ReportDialog_text__9gScH"};